'use client';

import { useEffect } from 'react';
import * as Sentry from '@sentry/nextjs';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className='flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center'>
      <h2 className='text-2xl font-semibold tracking-tight'>
        Something went wrong
      </h2>
      <p className='max-w-md text-sm text-muted-foreground'>
        An unexpected error occurred. Please try again or contact support if the
        problem persists.
      </p>
      {error.digest && (
        <p className='font-mono text-xs text-muted-foreground'>
          Error ID: {error.digest}
        </p>
      )}
      <button
        onClick={reset}
        className='rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90'
      >
        Try again
      </button>
    </div>
  );
}
